// extracted by mini-css-extract-plugin
export default {"container":"pro_1EuUy","icon":"pro_ico__AMnf"};